<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <CoachingSessionForm :baseCoachingSession="coachingSession" :basecoachingSessionName="name" :loading="loading" @submit-requested="submitRequested"></CoachingSessionForm>
  </div>
</template>
 
<script>
import { mapActions, mapState } from 'vuex'
import CoachingSessionForm from './CoachingSessionForm.vue'

export default {
  data() {
    return {
      coachingSession: null,
      name: this.$route.params.name,
      loading: true
    }
  },
  components: { CoachingSessionForm },
  computed:
  {
    ...mapState('coachingSessions', ['getCoachingSessionByIdOutput']),
  },
  methods: {
    ...mapActions('coachingSessions', ['getCoachingSessionById']),
    ...mapActions('coachingSessions', ['postCoachingSession']),
    submitRequested (input) {
      this.postCoachingSession(input);
    },
  },
  mounted: function () {
    if (this.$route.query.id) {
      this.getCoachingSessionById(this.$route.query.id);
    }
  },
  watch:
  {
    getCoachingSessionByIdOutput: function (output) {
      if (!output && !output.data) {
        this.$router.push({name: "CoachingSessions" });
      }
      else {
        this.coachingSession = { 
          title: output.data.title + " (2)",
          description: output.data.description,
          duration: output.data.duration,
          messageType: output.data.messageType,
          boards: output.data.boards,
          groups: output.data.groups,
          students: output.data.students,
          coachingSessionSpaces: output.data.coachingSessionSpaces,
        };
        this.loading = false;
      }
    }
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 